<div id="c">
    <div class="container">
        <p>
            Created by Vince Megia
        </p>
    </div>
</div>